module.exports = {
        srcSet: "/_next/static/images/notes-icon@3x-50-055ebe7ec13ac9a8.png"+" 50w"+","+"/_next/static/images/notes-icon@3x-100-c329a31025260332.png"+" 100w"+","+"/_next/static/images/notes-icon@3x-150-7110f96f8c035793.png"+" 150w",
        images: [{path: "/_next/static/images/notes-icon@3x-50-055ebe7ec13ac9a8.png",width: 50,height: 50},{path: "/_next/static/images/notes-icon@3x-100-c329a31025260332.png",width: 100,height: 100},{path: "/_next/static/images/notes-icon@3x-150-7110f96f8c035793.png",width: 150,height: 150}],
        src: "/_next/static/images/notes-icon@3x-150-7110f96f8c035793.png",
        toString: function(){return "/_next/static/images/notes-icon@3x-150-7110f96f8c035793.png"},
        
        width: 150,
        height: 150
      }